import { Typography } from "@material-ui/core";
import React from "react";

const Footer = ({ classes }) => {
  return (
    <div className={classes.copyright}>
      <Typography>Footer</Typography>
    </div>
  );
};
export default Footer;
